import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class CameraService {
    private camerasArray: Array<string> = [];
    private camerasMap: Map<string, string> = new Map<string, string>();

    constructor(private authService: AuthService) {
    }

    getCameras(computerType: string): string[] {
        this.camerasArray = [];
        this.camerasMap = new Map<string, string>();
        this.buildCamerasMap(computerType);
        this.buildCamerasArray();
        return this.camerasArray;
    }

    transform(cameras: string[]): string {
        let transformedCameras = '';
        cameras.forEach(c => transformedCameras += this.camerasMap.get(c));
        return transformedCameras;
    }

    private buildCamerasArray(): void {
        this.camerasMap.forEach((value: string, key: string) => {
            this.camerasArray.push(key);
        });
    }

    // The "official" camera order is FRPH(X).
    private buildCamerasMap(computerType: string): void {
        this.camerasMap.set('Front', 'F');
        this.camerasMap.set('Rear', 'R');
        this.camerasMap.set('Property', 'P');

        if (this.authService.userInfo.isInRole('jjr')) {
            this.camerasMap.set('Hopper', 'H');
        }

        if (this.computerTypeIsBlackMoth(computerType) || this.computerTypeIsRuggOn(computerType)) {
            this.camerasMap.set('Right', 'X');
        }
    }

    // noinspection JSMethodCanBeStatic
    private computerTypeIsBlackMoth(computerType: string): boolean {
        return (computerType.toUpperCase() === 'BLACKMOTH');
    }

    // noinspection JSMethodCanBeStatic
    private computerTypeIsRuggOn(computerType: string): boolean {
        return (computerType.toUpperCase() === 'RUGGON');
    }
}
